(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                vm.isSaving = true;
                Auth.changePassword(vm.currentPassword, vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                    vm.isSaving = false;
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                    vm.isSaving = false;
                });
            }
        }
    }
})();
